import { Modal } from "antd";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

type ConfirmDeleteOptions = {
  title?: string;
  content?: React.ReactNode;
  onOk: () => Promise<void> | void;
};

export function useConfirmDelete() {
  const { t } = useTranslation();

  const confirmDelete = useCallback(
    ({ title, content, onOk }: ConfirmDeleteOptions) => {
      Modal.confirm({
        title: title ?? t("handbook.modal.delete_title", "Удалить запись?"),
        content,
        okText: t("common.delete", "Удалить"),
        cancelText: t("common.cancel", "Отмена"),
        okButtonProps: { danger: true },
        onOk,
      });
    },
    [t]
  );

  return confirmDelete;
}
